module.exports = __webpack_public_path__ + "img/dashboard_orders.5e7b01e.png";